import React, { useContext } from "react";
import { Route as RouterRoute, Redirect, useLocation } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";
import {
	isMasterUser,
	isMasterAllowedPath,
	MASTER_HOME,
} from "../helpers/masterUser";

function Route({ component: Component, isPrivate = false, ...rest }) {
	const { isAuth, loading, user } = useContext(AuthContext);
	const location = useLocation();

	// Espera o refresh/boot da sessão — senão isAuth=false manda para /login
	// mesmo com refresh_token retornando 200 em seguida.
	if (loading) {
		return <BackdropLoading />;
	}

	if (!isAuth && isPrivate) {
		return (
			<Redirect to={{ pathname: "/login", state: { from: rest.location } }} />
		);
	}

	if (isAuth && !isPrivate) {
		const homePath = isMasterUser(user) ? MASTER_HOME : "/";
		return (
			<Redirect to={{ pathname: homePath, state: { from: rest.location } }} />
		);
	}

	if (
		isAuth &&
		isPrivate &&
		isMasterUser(user) &&
		!isMasterAllowedPath(location.pathname)
	) {
		return (
			<Redirect to={{ pathname: MASTER_HOME, state: { from: location } }} />
		);
	}

	return <RouterRoute {...rest} component={Component} />;
}

export default Route;
